var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"256","height":"256","fill":"none","key":0}),React.createElement("line",{"x1":"200","y1":"56","x2":"56","y2":"200","stroke":"currentColor","strokeWidth":"8","key":1}),React.createElement("line",{"x1":"200","y1":"200","x2":"56","y2":"56","stroke":"currentColor","strokeWidth":"8","key":2})]);
}

Close.defaultProps = {"width":"192","height":"192","fill":"currentColor","viewBox":"0 0 256 256"};

module.exports = Close;

Close.default = Close;
